<!-- <div class="d-flex position-relative w-100 h-100-t" *ngIf="data$ | async as data"> -->
<div class="d-flex position-relative w-100 h-100-t">
    <highcharts-chart [runOutsideAngular]="true" [Highcharts]="Highcharts" [options]="chartOptions" style="width: 100%; height: 100%;" (chartInstance)="onChartReady($event)"></highcharts-chart>
</div>